// src/layouts/MainLayout.jsx
import { useState, useEffect } from "react";
import StudentAvatar from "../components/common/Avatar/StudentAvatar";
import StudentHeader from "../components/common/StudentHeader";
import { getStudentNotifications } from "../services/notificationServices";
import "./MainLayout.css";

const StudentLayout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await getStudentNotifications();
        const list = Array.isArray(res) ? res : (res?.data ?? []);
        const pending = list.filter((n) => n.acknowledgementStatus === "Pending").length;
        setNotificationCount(pending);
      } catch {
        // silent fail
      }
    };
    fetchCount();
  }, []);

  return (
    <div className="main-layout">
      {sidebarOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside className={`sidebar ${sidebarOpen ? "sidebar--open" : ""}`}>
        <StudentAvatar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          notificationCount={notificationCount}
        />
      </aside>

      <div className="content-area">
        <StudentHeader
          title={title}
          sidebarOpen={sidebarOpen}
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          notificationCount={notificationCount}  // 👈 pass to header
        />
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
};

export default StudentLayout;